export default "__VITE_ASSET__DQuGipPm__"